import {useAppSelector} from "../../redux/hooks";
import {deviceStore} from "../../redux/device/deviceStore";

/** This is equivalent to deviceInfo.getIsMobile() */
export const useIsDeviceMobile = (): boolean =>
  useAppSelector(deviceStore.getDeviceIsMobile);

// This is unreliable. Don't use it. The UA string on iPads is indistinguishable from macOS.
// export const useIsDeviceTablet = (): boolean =>
//   useAppSelector(deviceStore.getDeviceIsTablet);

// This is unreliable. Don't use it. The UA string on iPads is indistinguishable from macOS.
// export const useIsDeviceTabletIPad = (): boolean =>
//   useAppSelector(deviceStore.getDeviceIsIPad);

export const useIsDeviceDesktop = (): boolean =>
  useAppSelector(deviceStore.getDeviceIsDesktop);

// This is unreliable. Don't use it. The UA string on iPads is indistinguishable from macOS.
// export const useIsDeviceDesktopMac = (): boolean =>
//   useAppSelector(deviceStore.getDeviceIsMacDesktop);

export const useIsDeviceDesktopWindows = (): boolean =>
  useAppSelector(deviceStore.getDeviceIsWindowsDesktop);
